var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "products_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15591",
    "data-name": "Path 15591",
    d: "M177.228,2023.487l3.954,5.859v8.7l-3.954,7.579-5.648,3.059-5.39-13.828Z",
    transform: "translate(-119.518 -2017.333)",
    fill: "#ffd5d5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15592",
    "data-name": "Path 15592",
    d: "M1.3,64.748H27.132l4.3,2.258H42.853l5.313-2.258H75.4v5.975L71.5,74.5H4.346L1.3,70.722Z",
    transform: "translate(0 0.333)",
    fill: "#c9f0ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M48,448h2.452v2.452H48Zm0,0",
    transform: "translate(-40.645 -379.355)",
    fill: "#0faceb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M80,448h2.452v2.452H80Zm0,0",
    transform: "translate(-67.742 -379.355)",
    fill: "#0faceb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M112,448h2.452v2.452H112Zm0,0",
    transform: "translate(-94.839 -379.355)",
    fill: "#0faceb"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M384,448h9.806v2.452H384Zm0,0",
    transform: "translate(-325.161 -379.355)",
    fill: "#0faceb"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M73.548,63.742V23.29a6.136,6.136,0,0,0-6.129-6.129H63.742a17.161,17.161,0,0,0-34.323,0H8.581A6.136,6.136,0,0,0,2.452,23.29V63.742H0v6.129A6.136,6.136,0,0,0,6.129,76H69.871A6.136,6.136,0,0,0,76,69.871V63.742ZM67.419,19.613A3.682,3.682,0,0,1,71.1,23.29V63.742H68.645V24.516a2.454,2.454,0,0,0-2.452-2.452H63.019a17.041,17.041,0,0,0,.527-2.452ZM32.583,12.657l13.01,5.422,4.455,13.362A14.687,14.687,0,0,1,32.583,12.657ZM52.377,30.676,47.983,17.492,57.8,7.673a14.682,14.682,0,0,1-5.424,23Zm-5.8-28.224A14.642,14.642,0,0,1,56.07,5.939L46.3,15.713,33.533,10.4A14.713,14.713,0,0,1,46.581,2.452ZM4.9,23.29a3.682,3.682,0,0,1,3.677-3.677H29.616a16.88,16.88,0,0,0,.527,2.452H9.806a2.454,2.454,0,0,0-2.452,2.452V63.742H4.9ZM73.548,69.871a3.682,3.682,0,0,1-3.677,3.677H6.129a3.682,3.682,0,0,1-3.677-3.677V66.194H27.706a9.525,9.525,0,0,0,6.407,2.452h7.775A9.525,9.525,0,0,0,48.3,66.194H63.742V63.742H47.3l-.359.359a7.1,7.1,0,0,1-5.053,2.092H34.112A7.1,7.1,0,0,1,29.059,64.1l-.358-.359H9.806V24.516H31.1a17.124,17.124,0,0,0,30.964,0h4.131V66.194h7.355Zm0,0",
    fill: "#0faceb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M127.806,295.355a3.657,3.657,0,0,0-2.036.619l-4.277-3.206a3.622,3.622,0,0,0,.184-1.09,3.677,3.677,0,1,0-7.355,0,3.64,3.64,0,0,0,.217,1.2l-6.865,5.493a3.6,3.6,0,0,0-4.125.18l-5.286-3.524a3.6,3.6,0,0,0,.124-.9,3.677,3.677,0,1,0-7.355,0,3.6,3.6,0,0,0,.124.9l-5.286,3.524a3.639,3.639,0,0,0-2.193-.743,3.677,3.677,0,1,0,3.677,3.677,3.6,3.6,0,0,0-.124-.9l5.286-3.524a3.609,3.609,0,0,0,4.386,0l5.286,3.524a3.6,3.6,0,0,0-.124.9,3.677,3.677,0,1,0,7.355,0,3.64,3.64,0,0,0-.217-1.2l6.865-5.493a3.63,3.63,0,0,0,3.968-.056l4.277,3.206a3.621,3.621,0,0,0-.184,1.09,3.677,3.677,0,1,0,3.677-3.677ZM83.677,302.71a1.226,1.226,0,1,1,1.226-1.226A1.228,1.228,0,0,1,83.677,302.71Zm11.032-7.355a1.226,1.226,0,1,1,1.226-1.226A1.228,1.228,0,0,1,94.71,295.355Zm11.032,7.355a1.226,1.226,0,1,1,1.226-1.226A1.228,1.228,0,0,1,105.742,302.71ZM118,292.9a1.226,1.226,0,1,1,1.226-1.226A1.228,1.228,0,0,1,118,292.9Zm9.806,7.355a1.226,1.226,0,1,1,1.226-1.226A1.228,1.228,0,0,1,127.806,300.258Zm0,0",
    transform: "translate(-67.742 -243.871)",
    fill: "#0faceb"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M99.613,176H80v17.161H99.613Zm-2.452,14.71H82.452V178.452h14.71Zm0,0",
    transform: "translate(-67.742 -149.032)",
    fill: "#0faceb"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M112,208h9.806v2.452H112Zm0,0",
    transform: "translate(-94.839 -176.129)",
    fill: "#0faceb"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M112,240h9.806v2.452H112Zm0,0",
    transform: "translate(-94.839 -203.226)",
    fill: "#0faceb"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M224,256h2.452v2.452H224Zm0,0",
    transform: "translate(-189.677 -216.774)",
    fill: "#0faceb"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M256,256h24.516v2.452H256Zm0,0",
    transform: "translate(-216.774 -216.774)",
    fill: "#0faceb"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsIcon);
export default __webpack_public_path__ + "static/media/products_icon.a5b20f36c0dfa91983ada4fa09341073.svg";
export { ForwardRef as ReactComponent };